import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import Input from "../forms/input/input";
import Button from "../button/button";

const JoinCourseModal = ({onSetId, onClose}) => {
    const [id, setId] = useState(0);
    return (
        <Modal
            onClose={onClose}
            title={window.L("teach.course.joinCourse")}
            >
            <Input
                placeholder={window.L("teach.course.inputCourseId")}
                onChange={v => {setId(v)}}
                defaultValue={id}
                autoFocus={true}
                />
            <div style={{textAlign: 'center'}}>
                <Button
                    theme={"submit"}
                    label={window.L('teach.button.enter')}
                    onClick={() => {
                        onSetId(id)
                    }}
                    />
            </div>
        </Modal>

    );
}

export default JoinCourseModal;
